<template>
  <div class="full-wrapper pannel">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <w-operation-state-info :params="params" :rsc-info="operationStateParams" :active="active"></w-operation-state-info>
        <el-row>
          <div class="row">
            <el-col :md="12" :lg="12">
              <w-perf-widget :show-change-btn="false">
                <span slot="perfHeader">구성 정보</span>
                <div slot="perfBody">
                  <el-col :md="24" :lg="12">
                    <table class="list-none-border">
                      <tr>
                        <th>장비명</th>
                        <td>{{ configInfoData.objName }}</td>
                      </tr>
                      <tr>
                        <th>IP</th>
                        <td>{{ configInfoData.ipaddress ? configInfoData.ipaddress : '-' }}</td>
                      </tr>
                      <tr>
                        <th>구동 시간</th>
                        <td>{{ configInfoData.netdeviceUptimeLabel }}</td>
                      </tr>
                      <tr>
                        <th>무선 AP 수</th>
                        <td>{{ configInfoData.apCount ? configInfoData.apCount : '-' }}</td>
                      </tr>
                    </table>
                  </el-col>
                  <el-col :md="24" :lg="12">
                    <table class="list-none-border">
                      <tr>
                        <th>장비 종류</th>
                        <td>{{ configInfoData.objtypeName ? configInfoData.objtypeName : '-' }}</td>
                      </tr>
                      <tr>
                        <th>제조사</th>
                        <td>{{ configInfoData.objCompanyName ? configInfoData.objCompanyName : '-' }}</td>
                      </tr>
                      <tr>
                        <th>모델</th>
                        <td>{{ configInfoData.objProductId ? configInfoData.objProductId : '-' }}</td>
                      </tr>
                      <tr>
                        <th>관리자 (정/부)</th>
                        <td>{{ configInfoData.majorLabel }}</td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>{{ configInfoData.minorLabel }}</td>
                      </tr>
                    </table>
                  </el-col>
                </div>
                <div slot="perfFooter">
                  <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }}</span>
                </div>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
            </el-col>
            <el-col :md="12" :lg="6">
              <w-perf-widget @change-widget-view="changeWidgetView('CLIENT', ...arguments)" :show-change-btn="false" :eventlevel="clientData.eventlevel">
                <span slot="perfHeader">접속자 수</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="memViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in clientData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="clientData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="clientViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in clientData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in clientData.backFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="6">
              <w-perf-widget @change-widget-view="changeWidgetView('ROGUE', ...arguments)" :show-change-btn="false" :eventlevel="rogueData.eventlevel">
                <span slot="perfHeader">비인가 AP수</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="rogueViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in rogueData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="rogueData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="rogueViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in rogueData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in rogueData.backFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('WIRELESSAP_TOPN', ...arguments)" :show-change-btn="false" :eventlevel="wirelessapTopnData.eventlevel">
                <el-row style="width: calc(100% - 10px);" type="flex" slot="perfHeader" justify="space-between">
                  <span>무선 AP Top5</span>
                  <el-select v-model="alignType" @change="loadBackData('WIRELESSAP_TOPN')">
                    <el-option v-for="align in alignTypeList" :key="align.value" :label="align.label" :value="align.value" />
                  </el-select>
                </el-row>
                <!-- BODY -->
                <el-row style="height:100%;" slot="perfBody">
                  <el-table-wrapper style="height:100%;" fit-height :data="wirelessapTopnData.backBody" :columns="wirelessapTopnTableColumns"
                    :show-custom-header="false" :show-search-tool="false" :pagination="false" :column-default="columnDefault" @cell-click="onCellClick">
                    <template slot-scope="scope" slot="objname-slot">
                     <span class="c-pointer">{{ scope.row.objRscInfo.objName }}</span>
                    </template>
                  </el-table-wrapper>
                </el-row>
                <!-- FOOTER -->
                <!-- <ul class="multi" v-if="processViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in processData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul> -->
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('CPU', ...arguments)" :show-change-btn="false" :eventlevel="cpuData.eventlevel">
                <span slot="perfHeader">CPU</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="cpuViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in cpuData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="cpuData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="cpuViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in cpuData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in cpuData.backFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="6">
              <w-perf-widget @change-widget-view="changeWidgetView('MEM', ...arguments)" :show-change-btn="false" :eventlevel="memData.eventlevel">
                <span slot="perfHeader">메모리</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="memViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in memData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="memData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="memViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in memData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in memData.backFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="6">
              <w-perf-widget @change-widget-view="changeWidgetView('TEMP', ...arguments)" :show-change-btn="false" :eventlevel="tempData.eventlevel">
                <span slot="perfHeader">온도</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="tempViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in tempData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="tempData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="tempViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in tempData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in tempData.backFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('RESPONSETIME', ...arguments)" :show-change-btn="false" :eventlevel="responsetimeData.eventlevel">
                <span slot="perfHeader">응답시간</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="responsetimeViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in responsetimeData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="responsetimeData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="responsetimeViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in responsetimeData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in responsetimeData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(responsetimeData.backBody, data) }" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="6">
              <w-perf-widget @change-widget-view="changeWidgetView('SYSLOG', ...arguments)" :show-change-btn="false" :eventlevel="syslogData.eventlevel">
                <span slot="perfHeader">Syslog</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="syslogViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in syslogData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-column-chart v-else slot="perfBody" :series="syslogData.backBody"></w-summary-column-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="syslogViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in syslogData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="multi" v-else slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in syslogData.backFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="6">
              <w-perf-widget @change-widget-view="changeWidgetView('SNMPTRAP', ...arguments)" :show-change-btn="false" :eventlevel="snmptrapData.eventlevel">
                <span slot="perfHeader">SNMP Trap</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="snmptrapViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in snmptrapData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-column-chart v-else slot="perfBody" :series="snmptrapData.backBody"></w-summary-column-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="snmptrapViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in snmptrapData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="multi" v-else slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in snmptrapData.backFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col><!-- :md="12" :lg="24" 삭제 191021 -->
              <w-perf-widget @change-widget-view="changeWidgetView('TRAFFIC', ...arguments)" :show-change-btn="false" :eventlevel="trafficData.eventlevel">
                <span slot="perfHeader">네트워크 트래픽 정보</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="trafficViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in trafficData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <!-- <w-summary-line-chart v-else slot="perfBody" :series="trafficData.backBody"></w-summary-line-chart> -->
                <w-summary-multi-line-chart v-else slot="perfBody" :series="trafficData.backBody" widget-key="NETDEVICE_TRAFFIC"></w-summary-multi-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="trafficViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in trafficData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in trafficData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(trafficData.backBody, data) }"/>
                </ul>
              </w-perf-widget>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import { clone, isEmpty, isNil, isEqual, camelCase } from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import { EMPTY_TEXT } from '@/utils/string';
import { getIntervalDatetimeParams } from '@/utils/date';
import { convertValuByUnit } from '@/utils/number';
import { routePathByObjId } from '@/utils/router';
import { AP_CONTROLLER } from '@/constants/summary';
import { columnDefault } from '@/constants/table';
import { menuDefine } from '@/constants/menu';
import api from '@/api/performance/ap-controller/ap-controller';
import summaryApi from '@/api/performance/summary/summary-info';
import WPerfWidget from '../components/PerfWidget';
import WPerfBodyInfo from '../components/PerfBodyInfo';
import WPerfFooterHInfo from '../components/PerfFooterHInfo';
import WPerfFooterVInfo from '../components/PerfFooterVInfo';
import WOperationStateInfo from '../components/OperationStateInfo';
import WSummaryLineChart from '../components/SummaryLineChart';
import WSummaryMultiLineChart from '../components/SummaryMultiLineChart';
import WSummaryStackedColumnChart from '../components/SummaryStackedColumnChart';
import WSummaryColumnChart from '../components/SummaryColumnChart';
import WEventInfoWidget from '../components/EventInfoWidget';

export default {
  name: 'WPerformanceApControllerSummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterHInfo,
    WPerfFooterVInfo,
    WOperationStateInfo,
    WSummaryLineChart,
    WSummaryStackedColumnChart,
    WSummaryColumnChart,
    WEventInfoWidget,
    WSummaryMultiLineChart,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'NMS',
        managetypeKey: 'ND',
      },
      operationStateParams: {
        rsctypeId: 'ND_RUNNINGSTATUS',
        rscId: 'NETDEVICE_ALIVE',
        rscKey: '_',
      },
      configInfoData: {},
      eventInfoData: {},
      clientViewIndex: 1,
      rogueViewIndex: 1,
      wirelessapTopnViewIndex: 1,
      cpuViewIndex: 1,
      memViewIndex: 1,
      tempViewIndex: 1,
      responsetimeViewIndex: 1,
      syslogViewIndex: 1,
      snmptrapViewIndex: 1,
      trafficViewIndex: 1,
      clientData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      rogueData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      wirelessapTopnData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      cpuData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      memData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      tempData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      responsetimeData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      syslogData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      snmptrapData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      trafficData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      alignType: 'CLIENT_COUNT',
      alignTypeList: [{ label: '접속자 수', value: 'CLIENT_COUNT' }, { label: '트래픽 IN', value: 'AP_TRAFFIC_BPS_IN' }, { label: '트래픽 OUT', value: 'AP_TRAFFIC_BPS_OUT' }],
      columnDefault,
      wirelessapTopnTableColumns: [
        {
          prop: 'objRscInfo.objName',
          label: '장비명',
          scopedSlot: 'objname-slot',
          sortable: false,
        },
        {
          prop: 'objRscInfo.ipaddress',
          label: 'IP',
          sortable: false,
        },
        {
          prop: 'CLIENT_COUNT',
          label: '접속자 수',
          align: 'right',
          width: 120,
          sortable: false,
        },
        {
          prop: 'AP_TRAFFIC_BPS_IN',
          label: '트래픽 IN',
          align: 'right',
          width: 120,
          formatter: this.convertValueByUnit,
          sortable: false,
        },
        {
          prop: 'AP_TRAFFIC_BPS_OUT',
          label: '트래픽 OUT',
          align: 'right',
          width: 120,
          formatter: this.convertValueByUnit,
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    getIntervalDatetimeParams,
    /**
     * 전체 화면 load(Tab 활성화 시, 화면 갱신 시 호출)
     * @author jeee12
     */
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();

        const widgetKeyList = ['CLIENT', 'ROGUE', 'WIRELESSAP_TOPN', 'CPU', 'MEM', 'TEMP', 'RESPONSETIME', 'SYSLOG', 'SNMPTRAP', 'TRAFFIC'];
        widgetKeyList.forEach((widgetKey) => {
          const widgetKeyLower = camelCase(widgetKey);
          this.changeWidgetView(widgetKey, this[`${widgetKeyLower}ViewIndex`]);
        });
      }
    },
    /**
     * 구성 정보 load
     * @author jeee12
     */
    loadConfInfoView() {
      api
        .getConfigurationInfo({
          objId: this.selectedNode.obj.objId,
          objtypeId: this.selectedNode.obj.objtypeId,
        })
        .then((response) => {
          if (response.data.success) {
            const configInfo = response.data.data;
            let majorLabel = EMPTY_TEXT;
            let minorLabel = EMPTY_TEXT;

            if (configInfo.majorName) {
              majorLabel = configInfo.majorDepartment ? `[${configInfo.majorDepartment}]${configInfo.majorName}` : `[${EMPTY_TEXT}]${configInfo.majorName}`;
            }
            if (configInfo.minorName) {
              minorLabel = configInfo.minorDepartment ? `[${configInfo.minorDepartment}]${configInfo.minorName}` : `[${EMPTY_TEXT}]${configInfo.minorName}`;
            }
            configInfo.majorLabel = majorLabel;
            configInfo.minorLabel = minorLabel;
            configInfo.checkDatetimeLabel = !isNil(configInfo.checkDatetime) ? moment(configInfo.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
            configInfo.netdeviceUptimeLabel = !isNil(configInfo.netdeviceUptimeCount) ? `${configInfo.netdeviceUptimeCount}일` : EMPTY_TEXT;
            // configInfo.netdeviceUptimeLabel = calcUptime(new Date(configInfo.netdeviceUptime), new Date());
            this.configInfoData = configInfo;
          }
        });
    },
    /**
     * 이벤트 정보 조회
     * @author kimjy
     */
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    /**
     * 위젯 전면 또는 후면 데이터 로드
     * @author jeee12
     * @param  {String} widgetKey 위젯 key (rsctypeId)
     * @param  {Integer} viewIndex 위젯 viewIndex
     */
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = camelCase(widgetKey);
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;
      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    /**
     * 전면 데이터 로드 함수
     * @author kimjy
     * @param  {String} widgetType 로드할 위젯 종류
     */
    loadFrontData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        objtypeId: this.selectedNode.obj.objtypeId,
        summaryWidgetKey: widgetKey,
        rscInfoList: AP_CONTROLLER.FRONT[widgetKey],
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });
      api.getSummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          this[camelCase(widgetKey).concat('Data')].frontBody = response.data.data.body;
          this[camelCase(widgetKey).concat('Data')].frontFooter = response.data.data.footer;
        }
      });
    },
    /**
     * 후면 데이터 로드 함수
     * @author kimjy
     * @param  {String} widgetType 로드할 위젯 종류
     */
    loadBackData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        objtypeId: this.selectedNode.obj.objtypeId,
        summaryWidgetKey: widgetKey,
        rscInfoList: AP_CONTROLLER.BACK[widgetKey],
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });
      if (isEqual(widgetKey, 'WIRELESSAP_TOPN')) {
        widgetParam.parentObjId = clone(widgetParam.objId);
        widgetParam.objId = null;
        widgetParam.rscId = this.alignType;
        widgetParam.rsctypeId = AP_CONTROLLER.BACK[widgetKey][0].rsctypeId;
      }
      api.getSummaryRscRsltBackList(widgetParam).then((response) => {
        if (response.data.success) {
          this[camelCase(widgetKey).concat('Data')].backBody = response.data.data.body;
          this[camelCase(widgetKey).concat('Data')].backFooter = response.data.data.footer;
          this[camelCase(widgetKey).concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
    /**
     * 후면 body 데이터 중 footer 데이터의 인덱스 검색
     * @author jeee12
     * @param  {[type]} backBodySeries [description]
     * @param  {[type]} footer         [description]
     * @return {[type]}                [description]
     */
    findFooterIndex(backBodySeries, footer) {
      return backBodySeries.findIndex((e) => {
        if (footer.rsckey) {
          return e.rscInfo.rscKeyName === footer.rscKeyName;
        } else if (e.rscInfo) {
          return e.rscInfo.rsctypeId === footer.rsctypeId && e.rscInfo.rscId === footer.rscId;
        }
        return null;
      });
    },
    /**
     * 단위 환산 formatter
     * @author jeee12
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertValueByUnit(row, column, value) {
      return convertValuByUnit(value, 'bps', true, true, true);
    },
    onCellClick(row, column) {
      if (column.property === 'objRscInfo.objName') {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/ap-controller/index.vue